import { render } from "./PvRadio.vue?vue&type=template&id=c809c376"
import script from "./PvRadio.vue?vue&type=script&lang=js"
export * from "./PvRadio.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__